export function serializePhotoShortcodesHtml(html = '') {
  if (!html) {
    return html
  }

  if (typeof document === 'undefined') {
    return html.replace(
      /<span[^>]*data-shortcode="(\[\[[^\]]+\]\])"[^>]*>[\s\S]*?<\/span>/g,
      '$1',
    )
  }

  const template = document.createElement('template')
  template.innerHTML = html

  template.content.querySelectorAll('[data-shortcode]').forEach(node => {
    node.replaceWith(document.createTextNode(node.getAttribute('data-shortcode')))
  })

  return template.innerHTML
}
